import React from "react";
import TerminalCard from "../../ui-components/terminal-card/terminalCard";

interface DockLoadingDistributorCellProps {
  distributorNumber: number;
}

/**
 * Dock-loading distributor display. Fetches terminal details via TerminalCard
 * (no name prop) and uses dock-loading SCSS for stacked, multi-line layout.
 */
const DockLoadingDistributorCell: React.FC<DockLoadingDistributorCellProps> = ({
  distributorNumber,
}) => (
  <TerminalCard
    terminalNumber={distributorNumber}
    keepTooltipInside={false}
    className="xgs-dock-loading__distributor-card"
  />
);

export default DockLoadingDistributorCell;
